import { put, select } from 'redux-saga/effects'

import { REMOVE_TOKENS, SET_SCOPE } from '@piconetworks/network-middleware'

import Auth from 'common/modules/auth'
import Internal from 'common/modules/internal'
import Loader from 'common/modules/loader'
import Zoid from 'common/modules/zoid'
import logger from 'common/logger'

import { creators } from '../actions'

const maxRetries = 3
let retries = 0

export default function* watchLogout() {
    if (retries >= maxRetries) {
        return
    }
    retries += 1

    const { publisherId, adBlockDetector, content } = yield select(Zoid.selectors.getXprops)

    yield put(Internal.creators.sendMessage({
        payload: {
            target: '*',
            ...Loader.creators.removeLoader({
                scope: 'user',
            }),
        },
    }))
    const loader = yield select(Loader.selectors.loader)
    logger.info('Arbiter - logout all apps', { loader })
    yield put(Internal.creators.sendMessage({
        payload: {
            target: '*',
            ...Auth.creators.logout({
                publisherId,
                withNetworkRequest: false,
            }),
        },
    }))

    yield put({ type: REMOVE_TOKENS })

    // remove access from frames first before removing your own access
    // because you won't have the ability to communicate with them
    // if you destroy your first
    yield put({
        type: SET_SCOPE,
        scope: 'guest',
    })

    yield put(Loader.creators.removeLoader({ scope: 'user' }))
    yield put(Auth.creators.logout({ publisherId }))

    yield put(creators.removeAccessToken())
    yield put(creators.removeRefreshToken())

    const adBlocking = yield adBlockDetector()

    const requestPayload = {
        ...content,
        adBlocking,
    }

    yield put(Loader.creators.getLoader({
        scope: 'guest',
        publisherId,
        requestPayload,
    }))
}
